import { z } from "zod";
import { BudgetCategorySchema } from "./budget";
export const VendorStatusSchema = z.enum(["inquiry", "contracted", "paid", "completed"]);
export const VendorSchema = z.object({
    id: z.string(),
    category: BudgetCategorySchema,
    name: z.string().min(1),
    contactName: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    email: z.string().email().nullable().optional().or(z.literal("")),
    website: z.string().url().nullable().optional().or(z.literal("")),
    address: z.string().nullable().optional(),
    status: VendorStatusSchema.default("inquiry"),
    contractAmount: z.number().nonnegative().default(0),
    depositPaid: z.number().nonnegative().default(0),
    notes: z.string().nullable().optional(),
    /** Firebase Storage path for uploaded contract/receipt source document. */
    documentStoragePath: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const VendorInputSchema = VendorSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
